function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null);

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "logo");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_1",
  "data-name": "Layer 1"
}, React.createElement("path", {
  className: "cls-1",
  d: "M285.15,122.65,408.92,336.53c15.85,27.37-4,61.59-35.64,61.59L125.72,395C94,395,74.23,360.82,90.08,333.45l123.77-210.8C229.7,95.28,269.3,95.28,285.15,122.65ZM225.3,200.39,165,307.89c-9.31,16.32,3.21,36.11,22.85,36.11H310.51c19.64,0,32.16-19.79,22.85-36.11L271,200.39C261.21,183.2,235.1,183.2,225.3,200.39Z",
  transform: "translate(-84.5 -102.12)"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 330 296"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/logo.e58cf512.svg";
export { SvgComponent as ReactComponent };